import { call, put, select, takeEvery } from 'redux-saga/effects';
import {
    SET_REVIEW_PANEL,
    GET_REVIEW_PANEL_LIST,
    DELETE_REVIEW_PANEL_BUY_ID,
    GET_REVIEW_PANEL_BUY_ID,
    GET_REVIEW_PANEL_MEMBER_LIST,
    ADD_REVIEW_PANEL_DATA,
    EDIT_REVIEW_PANEL_DATA
} from 'store/key';
import { produce } from 'utility/general';
import { setGlobalLoading } from 'store/global/reducer';

import API from 'api/call';
import { safeSaga } from 'store';

const initialState = {
    reviewPanelList: [
    ],
    reviewPanelTotal: 0,
    reviewPanelMemberList:null
};

function* getReviewPanelList(action) {
    const { params, callback } = action.payload;
    const { reviewPanel } = yield select();
    try {
        const result = yield call(API.reviewPanel.getReviewPanelList, { params });
        const res = result.data.result;
        reviewPanel.reviewPanelList = res.data;
        reviewPanel.reviewPanelTotal = res.total;
        yield put({
            type: SET_REVIEW_PANEL,
            payload: reviewPanel,
        });

        callback?.(res.data.length);
    } catch (error) {
        console.log('create reviewer failed:', error);
    };
}
function* deleteReviewPanel(action) {
    const {row,callback} = action.payload;
    setGlobalLoading(true);
    try {
        yield call(API.reviewPanel.deleteReviewPanel, row.id);
        callback?.();
    } catch (error) {
        console.log('emailDomain reducer.js error', error);
    }
    setGlobalLoading(false);
}
function* getReviewPanelById(action) {
    const { id, callback } = action.payload;
    try {
        const result = yield call(API.reviewPanel.getReviewPanelById, id);
        const res = result.data.result;
        callback?.(res);
    } catch (error) {
        console.log('create reviewer failed:', error);
    };
}
function* getReviewPanelMemberList(action) {
    const { params,callback } = action.payload;
    try {
        const result = yield call(API.reviewPanel.getReviewPanelMemberList, {params});
        const { reviewPanel } = yield select();
        reviewPanel.reviewPanelMemberList = result.data.result;
        yield put({
            type: SET_REVIEW_PANEL,
            payload: reviewPanel,
        });
        callback?.()
    } catch (error) {
        console.log('create reviewer failed:', error);
    };
}

function* addReviewPanel(action) {
    const { data,callback } = action.payload;
    setGlobalLoading(true);
    try {
        const res = yield call(API.reviewPanel.addReviewPanel, data);
        callback?.(res)
    } catch (error) {
        console.log('emailDomain reducer.js error', error);
    }
    setGlobalLoading(false);
}
function* editReviewPanel(action) {
    const { data,id,callback } = action.payload;
    setGlobalLoading(true);
    try {
        const res = yield call(API.reviewPanel.editReviewPanel, {data,id});
        callback?.(res)
    } catch (error) {
        console.log('emailDomain reducer.js error', error);
    }
    setGlobalLoading(false);
}
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_REVIEW_PANEL:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        default:
            return state;
    }
};

export function* watchReviewPanel() {
    yield takeEvery(GET_REVIEW_PANEL_LIST, safeSaga(getReviewPanelList));
    yield takeEvery(DELETE_REVIEW_PANEL_BUY_ID, safeSaga(deleteReviewPanel));
    yield takeEvery(GET_REVIEW_PANEL_BUY_ID, safeSaga(getReviewPanelById));
    yield takeEvery(GET_REVIEW_PANEL_MEMBER_LIST, safeSaga(getReviewPanelMemberList));
    yield takeEvery(ADD_REVIEW_PANEL_DATA, safeSaga(addReviewPanel));
    yield takeEvery(EDIT_REVIEW_PANEL_DATA, safeSaga(editReviewPanel));
}

export default reducer;
